import StoredLayout from '../../layouts/StoredLayout'
import DefaultForms from './DefaultForms'
export default StoredLayout(DefaultForms)
